import Modal from "../utbills/Modal"
import PendingUnitApprovals from "./PendingUnitApprovals"

// Opened from the dashboard bell: the units a manager assigned to this person
// that wait for them to Approve & Pay or Decline.
function TenancyInvitationModal({ invitations = [], accountReference = "", onChanged, onOpenRentals, onClose }) {
  return (
    <Modal title="Waiting for your approval" subtitle="Nothing is paid until you approve" icon="house-door" onClose={onClose}>
      <PendingUnitApprovals
        invitations={invitations}
        accountReference={accountReference}
        onChanged={onChanged}
        onOpenRentals={onOpenRentals}
        emptyText="No units are waiting for your approval."
      />
    </Modal>
  )
}

export default TenancyInvitationModal
